import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import immutableToJS from 'utils/immutableToJS';

import {
  currentCaseSelector,
} from 'redux/cases/selectors';

import {
  addHiddenWidget,
} from 'redux/ui/actions';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    caseInfo: PropTypes.shape({
      approvalStatus: PropTypes.string,
    }).isRequired,
  };

  Container.defaultProps = {
    caseInfo: {
      approvalStatus: '',
    },
  };

  function mapStateToProps(state) {
    return {
      caseInfo: currentCaseSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addHiddenWidget: payload => dispatch(addHiddenWidget(payload)),
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(
    immutableToJS(Container),
  );
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/EstimateInvoiceDecidedWidget/Container.js